<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="13.111" height="17.862" viewBox="0 0 13.111 17.862">
        <g id="SVG_submit_icon" transform="translate(-1121.09 -1134.663)">
        <path id="Path_92" data-name="Path 92" d="M-4735.651-14514.139h-2.948v9.228h11.111v-9.228h-2.882" transform="translate(5860.689 15656.437)" fill="none" stroke="#333" stroke-width="2"/>
        <line id="Line_9" data-name="Line 9" y1="11.538" transform="translate(1127.729 1136.076)" fill="none" stroke="#333" stroke-width="2"/>
        <path id="Path_93" data-name="Path 93" d="M-4725.376-14539.123l3.27-3.269,3.269,3.269" transform="translate(5849.836 15678.469)" fill="none" stroke="#333" stroke-width="2"/>
        </g>
    </svg>
</template>